module.exports = __webpack_public_path__ + "static/media/unsplash-parkinglot-hisphone.fccd3e95.jpg";